import { render, staticRenderFns } from "./process-m.vue?vue&type=template&id=3c760533&scoped=true"
import script from "./process-m.vue?vue&type=script&lang=js"
export * from "./process-m.vue?vue&type=script&lang=js"
import style0 from "./process-m.vue?vue&type=style&index=0&id=3c760533&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c760533",
  null
  
)

export default component.exports